import MarkdownRenderer from '@/components/MarkdownRenderer';
import { useGetMarketingDomains } from '@/hooks/useMarketingDomains';
import { Box, Card, CardContent, Divider, GridLegacy as Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
const MarketingDomains = ({
  productId
}: {
  productId: number;
}) => {
  const {
    data: domains,
    isLoading
  } = useGetMarketingDomains(productId);
  const sorted = useMemo(() => {
    if (!domains) {
      return [];
    }
    // 1) shallow-copy & sort domains by id
    return domains.slice().sort((a, b) => a.id - b.id)
    // 2) for each domain, shallow-copy & sort its subdomains by orderNumber
    .map(domain => ({
      ...domain,
      subdomains: domain.subdomains.slice().sort((a, b) => a.orderNumber - b.orderNumber)
    }));
  }, [domains]);
  if (isLoading) {
    return <Box>
        <Typography>Loading...</Typography>
      </Box>;
  }
  if (!domains || domains.length === 0) {
    return <Box>
        <Typography>No domains found.</Typography>
      </Box>;
  }
  return <Box data-sentry-element="Box" data-sentry-component="MarketingDomains" data-sentry-source-file="MarketingDomains.tsx">
      <Box mb={4} sx={{
      textAlign: 'center'
    }} data-sentry-element="Box" data-sentry-source-file="MarketingDomains.tsx">
        <Typography variant="h4" component="h2" fontWeight={600} gutterBottom data-sentry-element="Typography" data-sentry-source-file="MarketingDomains.tsx">
          We have questions on all areas of the exam
        </Typography>
      </Box>
      {sorted.map(domain => <Card key={domain.id} sx={{
      mb: 2
    }}>
          <CardContent>
            <Typography variant="h6" component="h3" fontWeight="bold">
              {domain.name}
            </Typography>
            <Divider sx={{
          my: 1
        }} />
            <Grid container spacing={2}>
              {domain.subdomains.map(subdomain => <Grid item xs={12} xl={6} key={subdomain.id}>
                  <Box mb={3} mt={1}>
                    <Typography variant="body1" component="h4" sx={{
                fontWeight: 700
              }}>
                      {`(${subdomain.orderNumber}) `}
                      {subdomain.name}
                    </Typography>
                  </Box>
                  <Box mb={3}>
                    <Typography variant="body2" color="text.secondary">
                      You will be asked
                      {' '}
                      <strong>
                        {subdomain.numRandomExamQuestions}
                        {' '}
                        questions
                      </strong>
                      {' '}
                      from this area on the exam.
                      {` `}
                      <strong style={{
                  fontStyle: 'italic'
                }}>
                        We have
                        {' '}
                        {subdomain.numQuestions}
                        {' '}
                        questions for you to practice.
                      </strong>
                    </Typography>
                  </Box>
                  <Typography variant="body2"><MarkdownRenderer content={subdomain.description} /></Typography>
                </Grid>)}
            </Grid>
          </CardContent>
        </Card>)}
    </Box>;
};
export default MarketingDomains;